// eslint-disable-next-line
export const MENU_MARCHE = 'sidebar.presse.marche';
export const MENU_FOURNISSEUR_SUPPORT = 'sidebar.achat.fournisseurSupport';
export const MENU_LIEU_LIVRAISON = 'sidebar.achat.lieuDeLivraison';
export const MENU_FOURNISSEURS = 'sidebar.achat.fournisseurs';
export const MENU_ACHAT = 'sidebar.achat.achats';
export const MENU_COMMANDES = 'sidebar.achat.commandes';
export const MENU_LIGNE_COMMANDE_ACHAT = 'sidebar.achat.ligneCommande';
export const MENU_BON_RECEPTION = 'sidebar.achat.bonReception';
export const MENU_FACTURES = 'sidebar.achat.factures';
export const MENU_SUIVI_ACHATS = 'sidebar.achat.suiviAchats';
export const MENU_PAIEMENTS_FACTURES = 'sidebar.achat.paiementsFactures';
export const MENU_JOURNAL_PAIEMENTS_FACTURES = 'sidebar.achat.journalPaiementsFactures';
export const MENU_LOT_PAIEMENT_FACTURES = 'sidebar.achat.lotPaiementFactures';
